// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".person-photo[data-v-6d55be86]{height:110px;width:110px}.mini-photo[data-v-6d55be86]{height:65px;width:65px}h3[data-v-6d55be86]{font-size:.85rem}h4[data-v-6d55be86]{font-weight:400}.preview h3[data-v-6d55be86],.preview h4[data-v-6d55be86]{font-size:1rem}.pin-to-top[data-v-6d55be86]{position:sticky;top:49px;z-index:1000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
